import React from "react";

import Address from "elements/Components/ContactUs/components/Address";
import AddressContainer from "elements/Components/ContactUs/components/AddressContainer";
import AddressWrapper from "elements/Components/ContactUs/components/AddressWrapper";
import City from "elements/Components/ContactUs/components/City";
import HubspotForm from "elements/Components/ContactUs/components/HubspotFormContainer";
import ImageContainer from "elements/Components/ContactUs/components/ImageContainer";
import ImageSection from "elements/Components/ContactUs/components/ImageSection";
import SectionContainer from "core/Components/SectionContainer";
import Wrapper from "elements/Components/ContactUs/components/Wrapper";

type Props = {
    data: ContactUs
};

const ContactUs: React.FC<Props> = ({ data }) => (
    <SectionContainer>
        <Wrapper>
            <ImageSection>
                {data.image?.id && (
                    <ImageContainer image={data.image} useFocusPoint={data.useFocusPoint} />
                )}

                <AddressContainer>
                    <AddressWrapper addressPosition={"left"}>
                        <City>{data.cityOfNZ}</City>
                        <Address>{data.addressOfNZ}</Address>
                    </AddressWrapper>
                    <AddressWrapper addressPosition={"right"}>
                        <City>{data.cityOfAU}</City>
                        <Address>{data.addressOfAU}</Address>
                    </AddressWrapper>
                </AddressContainer>
            </ImageSection>
            <HubspotForm data={data} />
        </Wrapper>
    </SectionContainer>
);

export default ContactUs;